/**
 * Service Interaction Routes
 * legacy app parent guard: canActivate: [AuthGuard, VendorRoleGuard]
 * Child route `precheck-myscript` also uses DisplayGuard.
 */

import { lazy } from 'react';
import { RouteConfig } from '../../types';

const DigitalSummary = lazy(() =>
  import('@src/apps/DigitalSummary/DigitalSummary').then((m) => ({ default: m.DigitalSummary }))
);
const CallPage = lazy(() =>
  import('@src/apps/CallSummary/CallSummary').then((m) => ({ default: m.CallSummary }))
);
const EDI = lazy(() =>
  import('@src/apps/ServiceInteractions/DigitalSolutions/EDI/EDI').then((m) => ({ default: m.EDI }))
);
const PreCheckMyScript = lazy(() =>
  import('@src/apps/ServiceInteractions/DigitalSolutions/PreCheckMyScript/PreCheckMyScriptComponent').then((m) => ({ default: m.PreCheckMyScriptComponent }))
);
const SmartEdits = lazy(() =>
  import('@src/apps/ServiceInteractions/DigitalSolutions/SmartEdits/SmartEditsComponent')
);
const SmartEditTopClaims = lazy(() =>
  import('@src/apps/ServiceInteractions/DigitalSolutions/SmartEditTopClaim/SmartEditTopClaimComponent')
);
const CareAssistTaxIdActivation = lazy(() =>
  import('@src/apps/ServiceInteractions/DigitalSolutions/CareAssistTaxIdActivation/CareAssistTaxIdActivationComponent')
);

export const serviceInteractionRoutes: RouteConfig[] = [
  {
    path: 'service-interaction',
    component: DigitalSummary,
    guards: ['auth', 'vendor'],
    data: {
      title: 'Service Interaction',
      breadcrumb: 'Service Interaction',
      preload: false,
      delay: true,
    },
  },
  {
    path: 'service-interaction/calls',
    component: CallPage,
    guards: ['auth', 'vendor'],
    data: {
      title: 'Calls',
      breadcrumb: 'Calls',
      preload: false,
      delay: true,
    },
  },
  {
    path: 'service-interaction/selfservice',
    component: DigitalSummary,
    guards: ['auth', 'vendor'],
    data: {
      title: 'Digital Solutions Summary',
      breadcrumb: 'Summary',
      preload: false,
      delay: true,
    },
  },
  {
    path: 'service-interaction/edi',
    component: EDI,
    guards: ['auth', 'vendor'],
    data: {
      title: 'EDI',
      breadcrumb: 'EDI',
      preload: false,
      delay: true,
    },
  },
  {
    path: 'service-interaction/precheck-myscript',
    component: PreCheckMyScript,
    guards: ['auth', 'vendor', 'display'],
    data: {
      title: 'PreCheck MyScript',
      breadcrumb: 'Alternate Display and Switch',
      preload: false,
      delay: true,
    },
  },
  {
    path: 'service-interaction/smart-edits',
    component: SmartEdits,
    guards: ['auth', 'vendor'],
    data: {
      title: 'Smart Edits',
      breadcrumb: 'Smart Edits',
      preload: false,
      delay: true,
    },
  },
  {
    path: 'service-interaction/smart-edits/top-claims',
    component: SmartEditTopClaims,
    guards: ['auth', 'vendor'],
    data: {
      title: 'Smart Edits Top Claims',
      breadcrumb: 'Top Claims',
      preload: false,
      delay: true,
    },
  },
  {
    path: 'PointofCareAssist/EMR-TaxId',
    component: CareAssistTaxIdActivation,
    guards: ['auth', 'vendor'],
    data: {
      title: 'EMR Tax ID Activation',
      breadcrumb: 'EMR Tax ID Activation',
      preload: false,
      delay: true,
    },
  },
];
